/**
 * Las imágenes originales pesan más de lo que se muestra en pantalla. Este
 * proxy (wsrv.nl, gratuito y con CDN) las redimensiona al ancho exacto, las
 * entrega en WebP comprimido y con caché de larga duración.
 */
const PROXY = 'https://wsrv.nl/'

export function optimizedImage(url: string, width: number, quality = 72): string {
  const params = new URLSearchParams({
    url,
    w: String(width),
    output: 'webp',
    q: String(quality),
  })
  return `${PROXY}?${params.toString()}`
}

export function optimizedSrcSet(
  url: string,
  widths: number[],
  quality?: number,
): string {
  return widths
    .map((width) => `${optimizedImage(url, width, quality)} ${width}w`)
    .join(', ')
}

/** Mockup del hero: anchos disponibles y ancho real en cada breakpoint. */
export const HERO_WIDTHS = [480, 720, 960, 1240]
export const HERO_SIZES =
  '(min-width: 1024px) 672px, (min-width: 640px) 576px, calc(100vw - 48px)'

/** Portadas de los bonus: 64px en móvil, 96px desde sm. */
export const BONUS_WIDTHS = [128, 192, 288]
export const BONUS_SIZES = '(min-width: 640px) 96px, 64px'
